import { render, staticRenderFns } from "./CompetitionOverview.vue?vue&type=template&id=2e18ebb4&scoped=true"
import script from "./CompetitionOverview.vue?vue&type=script&lang=js"
export * from "./CompetitionOverview.vue?vue&type=script&lang=js"
import style0 from "./CompetitionOverview.vue?vue&type=style&index=0&id=2e18ebb4&prod&lang=scss"
import style1 from "./CompetitionOverview.vue?vue&type=style&index=1&id=2e18ebb4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e18ebb4",
  null
  
)

export default component.exports